<template>
  <div :class="$style.app">
    <World
      v-bind="$attrs"
    />
    <PlayerStatus />
  </div>
</template>

<script>
import PlayerStatus from '../components/PlayerStatus.vue'
import World from './components/World'

export default {
  components: {
    World,
    PlayerStatus,
  },
}
</script>

<style module lang="scss">
.app {
  :global {
    @import '~@/style/global';
    @include root-styles;
  }
}
</style>
